import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCommentAltLines } from '@fortawesome/pro-solid-svg-icons';
import styles from './index.module.css';

const NotificationIcon = ({ count, text }) => (
  <div className={styles['notification-wrapper']}>
    <div className={styles['icon-container']}>
      <FontAwesomeIcon
        icon={faCommentAltLines}
        className={styles['notification-icon']}
      />
      {count > 0 && <span className={styles['numberCircle']}>{count}</span>}
    </div>
    <span className={styles['notification-text']}>{text}</span>
  </div>
);

export default NotificationIcon;
